export default "__VITE_ASSET__f520b9c9__"